import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./tailwind.css";
import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import VueCookies from "vue-cookies";
import VueApexCharts from "vue3-apexcharts";

// import fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {} from "@fortawesome/free-brands-svg-icons";
import { faEye, faFolderOpen, faHourglassHalf } from "@fortawesome/free-regular-svg-icons";
import {
  faXmark,
  faBars,
  faList,
  faHandshake,
  faWallet,
  faDashboard,
  faChartLine,
  faHomeAlt,
  faCog,
  faSlidersH,
  faSearch,
  faUser,
  faHistory,
  faPrint,
  faCalendarAlt,
  faSun,
  faMoon,
  faCirclePlus,
  faPlus,
  faXmarkSquare,
  faCheck,
  faTags,
  faCartArrowDown,
  faTruck,
  faBarcode,
  faChevronDown,
  faDolly,
  faChevronLeft,
  faChevronRight,
  faEllipsisV,
  faBorderAll,
  faWifi,
  faCaretDown,
  faCaretUp,
  faDownload,
  faUndo,
  faAngleDoubleRight,
  faAngleDoubleLeft
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faXmark,
  faBars,
  faList,
  faHandshake,
  faWallet,
  faDashboard,
  faChartLine,
  faHomeAlt,
  faCog,
  faSlidersH,
  faSearch,
  faUser,
  faHistory,
  faPrint,
  faCalendarAlt,
  faSun,
  faMoon,
  faCirclePlus,
  faPlus,
  faXmarkSquare,
  faCheck,
  faTags,
  faCartArrowDown,
  faFolderOpen,
  faTruck,
  faHourglassHalf,
  faBarcode,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faDolly,
  faEye,
  faEllipsisV,
  faBorderAll,
  faWifi,
  faCaretDown,
  faCaretUp,
  faDownload,
  faUndo,
  faAngleDoubleRight,
  faAngleDoubleLeft
);

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(VueApexCharts)
  .use(store)
  .use(router)
  .use(Vue3Toasity, { rtl: true })
  .use(VueCookies)
  .mount("#app");
